import React, { useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/services'
import Editor from 'components/editor'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'

const EditModal = ({ data, handleRefresh, categories }) => {
  const AppService = useAppServices()
  const [open, setOpen] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [description, setDescription] = useState(data?.description || '')

  const appName = data?.app_name || data?.category_id?.app_name || ''
  const filteredCategories = categories.filter(category => category.app_name === appName)

  const [formValues, setFormValues] = useState({
    name: data?.name || '',
    category_id: data?.category_id?._id || '',
    instruction: data?.instruction || '',
    app_name: appName,
    app_id: data?.category_id?.app_id || '',

  })

  const handleModal = () => setOpen(true)
  const closeModal = () => setOpen(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormValues(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const selectedCategory = categories.find(cat => cat._id === formValues.category_id)

    const payload = {
      ...formValues,
      description,
      _id: data._id,
      category_id: selectedCategory,
      app: {
        name: formValues.app_name,
        app_id: formValues.app_id,
      },
    }

    const { response } = await AppService.AppsChecklist.update_onboard({ payload })

    if (response) {
      setProcessing(false)
      closeModal()
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>

      <MDModal open={open} onClose={closeModal}>
        <MDBox component="form" onSubmit={handleSubmit} sx={style}>
          <MDTypography variant="h5" mb={2}>
            Edit Checklist App
          </MDTypography>

          {/* Static App Display */}
          <MDBox mb={2}>
            <MDTypography variant="button" fontWeight="bold">
              App:
            </MDTypography>
            <MDTypography>{formValues.app_name}</MDTypography>
          </MDBox>

          {/* Category Dropdown */}
          <MDBox mb={2}>
            <FormControl fullWidth>
              <InputLabel id="category-label">Category</InputLabel>
              <Select
                labelId="category-label"
                name="category_id"
                value={formValues.category_id}
                label="Category"
                onChange={handleChange}
                required
              >
                {filteredCategories.map((category) => (
                  <MenuItem key={category._id} value={category._id}>
                    {category.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>

          {/* Name */}
          <MDBox mb={2}>
            <MDTypography variant="button">Name</MDTypography>
            <MDInput
              name="name"
              fullWidth
              required
              value={formValues.name}
              onChange={handleChange}
            />
          </MDBox>

          {/* Description */}
          <MDBox mb={2}>
            <MDTypography variant="button">Description</MDTypography>
            <Editor handleChange={setDescription} data={description} />
          </MDBox>

          {/* Instruction */}
          <MDBox mb={2}>
            <MDTypography variant="button">Instruction</MDTypography>
            <MDInput
              name="instruction"
              fullWidth
              required
              value={formValues.instruction}
              onChange={handleChange}
            />
          </MDBox>

          {/* Actions */}
          <MDBox display="flex" justifyContent="flex-end">
            <MDButton variant="gradient" color="secondary" onClick={closeModal} sx={{ mt: 2, mb: 1 }}>
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              type="submit"
              sx={{ mt: 2, mb: 1, ml: 1 }}
              loading={processing}
              disabled={processing}
            >
              Update
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditModal
